import { PatientServiceTerm } from "@mgdx/api/lib/patient/patient";
import { parseDateTz } from "@mgdx/shared/src/utils/parseDateTz";
import { useMemo } from "react";

import { CurrentUserState } from "../stores/currentUserStore";

type UseIsRequiredAgreementNewTermsArgs = {
  currentPathname: string;
  currentServiceTerm: PatientServiceTerm | undefined;
  currentUser: CurrentUserState;
};

export const useIsRequiredAgreementNewTerms = ({
  currentPathname,
  currentServiceTerm,
  currentUser,
}: UseIsRequiredAgreementNewTermsArgs) =>
  useMemo<boolean>(() => {
    if (["/rules", "/liff"].some((path) => currentPathname.startsWith(path))) {
      return false;
    }

    if (!currentUser.isLoggedIn) {
      return false;
    }

    if (!currentUser.userInfo) {
      return false;
    }

    const yqbAgreedTime = parseDateTz(currentUser.userInfo.yqbAgreedTime);

    if (!yqbAgreedTime) {
      // 同意日付がない場合は同意が必要
      return true;
    }

    const newTermsLatestRevisionDate = parseDateTz(currentServiceTerm?.revision);

    if (!newTermsLatestRevisionDate) {
      // 改定日付を取得中の場合は不要
      return false;
    }

    return newTermsLatestRevisionDate.isSameOrAfter(yqbAgreedTime);
  }, [currentPathname, currentServiceTerm, currentUser.isLoggedIn, currentUser.userInfo]);
